import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const DocumentMetadataModal = ({ 
  files, 
  sectionTitle, 
  onConfirm, 
  onCancel 
}) => {
  const [metadata, setMetadata] = useState(
    files.map((file) => ({
      fileName: file.name,
      title: '',
      description: ''
    }))
  );

  const handleMetadataChange = (index, field, value) => {
    setMetadata((prev) => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [field]: value };
      return updated;
    });
  };

  const handleConfirm = () => {
    // Validate that at least title is provided for each file
    const isValid = metadata.every((item) => item.title?.trim());
    if (!isValid) {
      alert('Please provide a title for each file');
      return;
    }
    onConfirm(files, metadata);
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-card rounded-2xl shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="sticky top-0 bg-card border-b border-border p-6 flex items-center justify-between">
          <div>
            <h2 className="text-2xl font-bold text-foreground">Add Document Details</h2>
            <p className="text-sm text-muted-foreground mt-1">
              Provide a title and description for {files.length} file(s) in {sectionTitle}
            </p>
          </div>
          <button
            onClick={onCancel}
            className="text-muted-foreground hover:text-foreground transition-colors"
          >
            <Icon name="X" size={24} />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-6">
          {metadata.map((item, index) => (
            <div
              key={index}
              className="border border-border rounded-lg p-5 bg-muted/30"
            >
              <div className="flex items-start gap-3 mb-4">
                <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <Icon name="File" size={20} color="var(--color-primary)" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-medium text-foreground truncate text-sm">
                    {item.fileName}
                  </p>
                </div>
              </div>

              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-foreground mb-2">
                    Title <span className="text-error">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="e.g., High School Diploma"
                    value={item.title}
                    onChange={(e) =>
                      handleMetadataChange(index, 'title', e.target.value)
                    }
                    className="w-full px-4 py-2 border border-border rounded-lg bg-background text-foreground placeholder-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-foreground mb-2">
                    Description (optional)
                  </label>
                  <textarea
                    placeholder="Add context or details about this document..."
                    value={item.description}
                    onChange={(e) =>
                      handleMetadataChange(index, 'description', e.target.value)
                    }
                    rows={3}
                    className="w-full px-4 py-2 border border-border rounded-lg bg-background text-foreground placeholder-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent resize-none"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className="sticky bottom-0 bg-card border-t border-border p-6 flex items-center gap-3 justify-end">
          <Button variant="outline" onClick={onCancel}>
            Cancel
          </Button>
          <Button onClick={handleConfirm}>
            Add Documents
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DocumentMetadataModal;
